export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8115.b3cd02de.jpg";